import React, { useMemo } from "react";

// Simple SVG line chart without external deps
function LineChart({ data, height = 240 }) {
  const paddingX = 24;
  const paddingY = 24;
  const width = 600; // container can shrink via CSS

  const values = data.map((d) => d.value);
  const maxVal = Math.max(1, ...values);
  const stepX = (width - paddingX * 2) / Math.max(1, data.length - 1);
  const scaleY = (height - paddingY * 2) / maxVal;

  const points = data.map((d, i) => {
    const x = paddingX + i * stepX;
    const y = height - paddingY - d.value * scaleY;
    return `${x},${y}`;
  });

  // y-axis ticks (0, 25%, 50%, 75%, 100%)
  const ticks = [0, 0.25, 0.5, 0.75, 1].map((t) => Math.round(t * maxVal));

  return (
    <svg viewBox={`0 0 ${width} ${height}`} className="w-full h-auto">
      {ticks.map((t, i) => {
        const y = height - paddingY - t * scaleY;
        return (
          <g key={i}>
            <line
              x1={paddingX}
              x2={width - paddingX}
              y1={y}
              y2={y}
              className="stroke-gray-200 dark:stroke-gray-800"
              strokeWidth="1"
            />
            <text
              x={0}
              y={y + 4}
              className="fill-gray-400 dark:fill-gray-500"
              fontSize="10"
            >
              {t}
            </text>
          </g>
        );
      })}

      <polyline
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="text-indigo-600 dark:text-indigo-400"
        points={points.join(" ")}
      />
      {data.map((d, i) => {
        const x = paddingX + i * stepX;
        const y = height - paddingY - d.value * scaleY;
        return (
          <circle
            key={i}
            cx={x}
            cy={y}
            r={3}
            className="fill-indigo-600 dark:fill-indigo-400"
          />
        );
      })}
    </svg>
  );
}

export default function UserGraph({ data }) {
  const series = useMemo(() => {
    if (Array.isArray(data) && data.length > 0) return data;
    return [
      { label: "Jan", value: 2 },
      { label: "Feb", value: 5 },
      { label: "Mar", value: 10 },
      { label: "Apr", value: 12 },
      { label: "May", value: 18 },
      { label: "Jun", value: 22 },
      { label: "Jul", value: 28 },
      { label: "Aug", value: 30 },
      { label: "Sep", value: 35 },
      { label: "Oct", value: 38 },
      { label: "Nov", value: 40 },
      { label: "Dec", value: 45 },
    ];
  }, [data]);

  return (
    <div className="p-4 rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-bg-darkSecondary shadow-sm">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-base font-semibold text-gray-900 dark:text-white">
          Users graph
        </h3>
        <span className="px-3 py-1 rounded-md text-sm border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300">
          Month
        </span>
      </div>
      <LineChart data={series} />
      <div
        className={`mt-2 grid grid-cols-12 gap-2 text-[10px] text-gray-500 dark:text-gray-400`}
      >
        {series.map((d, i) => (
          <div key={i} className="truncate text-center">
            {d.label}
          </div>
        ))}
      </div>
    </div>
  );
}
